import Action from "./Action";
import Shape, {LineStyleType} from "../Main/Shape.js";
import {Serialization} from "../Main/Serializer";

export default class ShapeChangeLineStyleTypeAction implements Action {

    private readonly oldLineStyleType: LineStyleType;

    constructor(private shape: Shape, private newLineStyleType: LineStyleType) {
        this.oldLineStyleType = this.shape.getLineStyleType();
    }

    public apply() {
        this.shape.setLineStyleType(this.newLineStyleType);
    }

    public revert() {
        this.shape.setLineStyleType(this.oldLineStyleType);
    }

    public merge(newAction: Action): boolean {
        return false;
    }

    public serializeForDebug(): Serialization {
        return {
            shape: this.shape.id,
            oldLineStyleType: this.oldLineStyleType,
            newLineStyleType: this.newLineStyleType,
        };
    }
}
